import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { SearchBillingConfigMasterComponent } from "../search-billing-config-master/search-billing-config-master.component";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { from, Observable, Subject } from "rxjs";
import { map, startWith, takeUntil } from "rxjs/operators";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { CategoryModel } from "app/dashboard/Models/category.model";
import { ConfigurationService } from "../configuration.service";
import { IPDService } from "app/ipd/Services/ipdServices.service";
import { DashboardService } from "app/dashboard/dashboard.service";
import { BillingserviceService } from "app/billing/billingService.service";
import { AuthService } from "app/auth/auth.service";
import { BranchMatserService } from "app/masters/branch-matser.service";
import { BillConfigurationrinsertModel, BillConfigurationrModel } from "app/masters/models/surgeryMaster.model";

@Component({
  selector: "app-patient-billing-configuration",
  templateUrl: "./patient-billing-configuration.component.html",
  styleUrls: ["./patient-billing-configuration.component.scss"],
})
export class patientBillingConfigurationComponent implements OnInit {
  destroypatientbilling$: Subject<boolean> = new Subject<boolean>();
  private filteredbulkDoctorArray: Observable<any[]>;
  validBillTypeIds = [1, 2, 3, 4, 101, 201];
  editCache: any = {};
  patinentBillingForm: FormGroup;
  BranchId: FormControl;
  PartyId: FormControl;
  CatId: FormControl;
  BillTypeId: FormControl;
  BillsericeId: FormControl;
  doctorId: FormControl;
  refId: FormControl;
  rateListId: FormControl;
  freshServiceId: FormControl;
  reviewServiceId: FormControl;
  followUpId: FormControl;
  selectedValue: any
  enabledisablebtn: boolean = true;
  private radiocheck1:any
  private radiocheck2:any
  private radiocheck3:any
  private branchIndex = [];
  private branchList: any = [];
  private partylist: any = [];
  private getDrList: any = [];
  private rateListArray: any = [];
  private serviceList: any = [];
  private BillingNarrationArray:any[] = [];
  private getBillingNarrationArray: any = []
  public selectbillmstObj: any = {};
  private addbillConobj: BillConfigurationrModel = {}
  private insertbillingConfig: BillConfigurationrinsertModel = {}
  private filteredBranchArray: Observable<any[]>;
  private filterpartyArray: Observable<any[]>;
  private filtercatArray: Observable<any[]>;
  private filterbillTypeArray: Observable<any[]>;
  private filterbillServiceArray: Observable<any[]>;
  private filterdoctorArray: Observable<any[]>;
  private filterRefArray: Observable<any[]>;
  private filterRatelistArray: Observable<any[]>;
  private filterservicelistArray: Observable<any[]>;
  private filterRservicelistArray: Observable<any[]>;
  private filterfollowUplistArray: Observable<any[]>;
  private patientdoctorCtrl: FormControl;
  constructor(public dialog: MatDialog,
    private opdvisitService: OpdVisitService,
    private fb: FormBuilder,
    private configurationService: ConfigurationService,
    private branchMatserService: BranchMatserService,
    private ipdservice: IPDService,
    private dashboardService: DashboardService,
    private billingService: BillingserviceService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.loadPaitentbillingForm();
    this.getBranchList();
    this.getpartyList();
    this.GetBillType();
    this.getBillMasterservice();
    this.catControll();
    this.refControll();
    this.getDoctorBrach();
    this.getRateList();
    this.getsearcgbrach();
    this.getServiceList();
    this.BranchId = new FormControl();
    this.PartyId = new FormControl();
    this.BillTypeId = new FormControl();
    this.BillsericeId = new FormControl();
    this.rateListId = new FormControl();
    this.doctorId = new FormControl();
    this.freshServiceId = new FormControl();
    this.reviewServiceId = new FormControl();
    this.followUpId = new FormControl();
  }


  loadPaitentbillingForm() {
    this.patinentBillingForm = this.fb.group({
      branchName: '',
      partyName: '',
      category: '',
      billType: '',
      billSeries: '',
      doctorName: '',
      referralBy: '',
      rateList: '',
      isActive: '',
      approvalSystem: '',
      noofDays: '',
      freshService: '',
      reviewService: '',
      followUp: '',
      BranchId: ['', [Validators.required]],
      billtype: '',
      narration: ''
    });
  }

  getBranchList() {
    this.configurationService.getBranchMaster().subscribe(data => {
      this.branchList = data;
       this.branchControll();
    });
  }

  branchControll() {
    this.BranchId = new FormControl();
    this.filteredBranchArray = this.BranchId.valueChanges
      .pipe(
        startWith(''),
        map(country => country ? this.filterBranchfunction(country) : this.branchList.slice())
      );
  }

  filterBranchfunction(name: string) {
    return this.branchList.filter(item =>
      item.branchName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getbranchObj(e) {
    var val = e.option.id;
    this.configurationService.selectedbillConfigData.fK_BranchId = val
    this.enabledisablebtn = false;
  }

  getpartyList() {
    this.ipdservice.get_partytpa().subscribe((res) => {
      this.partylist = res;
      this.partyControll();
    })
  }


  partyControll() {
    this.PartyId = new FormControl();
    this.filterpartyArray = this.PartyId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterPartyfunction(item) : this.partylist.slice())
      );
  }

  filterPartyfunction(name: string) {
    return this.partylist.filter(item =>
      item.partyName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getpartyObj(e) {
    var val = e.option.id;
    this.configurationService.selectedbillConfigData.fK_PartyId = val
  }

  clearPartyId() {
    if (!this.configurationService.selectedbillConfigData.partyName ||  this.configurationService.selectedbillConfigData.partyName.toString().trim() === '') {
      this.configurationService.selectedbillConfigData.fK_PartyId = null;
    }
  }
  

  catControll() {
    this.CatId = new FormControl();
    this.filtercatArray = this.CatId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterCatfunction(item) : this.dashboardService.categories.slice())
      );
  }

  filterCatfunction(name: string) {
    return this.dashboardService.categories.filter(item =>
      item.categoryName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }
  getcatObj(e) {
    var val = e.option.id;
    this.configurationService.selectedbillConfigData.fK_CategoryId = val
  }

  clearCategoryId(){
    if (!this.configurationService.selectedbillConfigData.categoryName ||  this.configurationService.selectedbillConfigData.categoryName.toString().trim() === '') {
      this.configurationService.selectedbillConfigData.fK_CategoryId = null;
    }
  }


  newRowIndex: number | null = null;
  addnewRow() {
    const isEditing = this.BillingNarrationArray.some((row) => row.edit === true);
    if (isEditing) {
      this.dashboardService.openSnackBar('You Cannot Add More Than One Row', 'OK');
      return;
    }
    this.addbillConobj = {
      isEdit: false,
      narration:null,
      fK_BillTypeId : null,
      pK_TranId :0,
      edit: true
    };
    this.BillingNarrationArray.push(this.addbillConobj);
   if(this.BillingNarrationArray.length > 0){
     this.newRowIndex = this.BillingNarrationArray.length - 1;
   }
    this.updateEditCache();
  }


  updateEditCache(): void {
    debugger;
    this.BillingNarrationArray.forEach((item, index) => {
      this.editCache[index] = {
        edit: item.edit || false,
        data: { ...item }
      };
    });
  console.log(this.BillingNarrationArray)
  }

 
  Edit(item:any,index:number) {
      this.BillingNarrationArray.forEach((row) => (row.edit = false));
      this.BillingNarrationArray[index].isEdit = true
      this.updateEditCache();
      console.log(this.BillingNarrationArray)
      this.editCache[index].edit = true;
  }
  deleteArray =[];
  deleteItem(item: any, index: number) {
  if (item.pK_TranId != 0) {
    this.BillingNarrationArray[index].isEdit = true;
    this.BillingNarrationArray[index].IsDelete = true;
    this.deleteArray.push(
     this.BillingNarrationArray[index]
    )
  }
    this.BillingNarrationArray.splice(index, 1);
  }

  saveedit(index: number, item: any) {
    item.edit = false;
    if (!item.fK_BillTypeId) {
      this.dashboardService.openSnackBar('Please Enter BillType', 'OK');
      return;
    }
    if (!item.narration || item.narration.trim() === '') {
      this.dashboardService.openSnackBar('Please Enter narration','OK');
      return;
    }

    const isValid = this.BillingNarrationArray.every(item => 
      this.validBillTypeIds.indexOf(Number(item.fK_BillTypeId)) !== -1);
    if (!isValid) {
      this.dashboardService.openSnackBar('Please Enter Valid Bill Type','OK');
      return;
    }
    this.editCache[index].edit = false;
  }

  canceledit(index: number, item: any) {
    if (!item.fK_BillTypeId && !item.narration && item.pK_TranId == 0) {
      this.BillingNarrationArray.splice(index, 1);
    } else {
      this.BillingNarrationArray[index] = { ...this.editCache[index].data };
    }
    this.editCache[index].edit = false;
  }

  GetBillType() {
    this.billingService.get_typelist().pipe(takeUntil(this.destroypatientbilling$)).subscribe((data: any[]) => {
      this.billingService.billtype = data;
      this.billTypeControll();
    })
  }


  billTypeControll() {
    this.BillTypeId = new FormControl();
    this.filterbillTypeArray = this.BillTypeId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterbillTypefunction(item) : this.billingService.billtype.slice())
      );
  }

  filterbillTypefunction(name: string) {
    return this.billingService.billtype.filter(item =>
      item.billTypeName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getbilltypeObj(e) {
    var val = e.option.id;
    this.configurationService.selectedbillConfigData.fK_BillTypeId = val
  }

  clearbillTypeId(){
    if (!this.configurationService.selectedbillConfigData.billTypeName ||  this.configurationService.selectedbillConfigData.billTypeName.toString().trim() === '') {
      this.configurationService.selectedbillConfigData.fK_BillTypeId = null;
    }
  }

  getBillMasterservice() {
    this.billingService.get_BillMasterService(this.authService.selectedbillingcompany, this.authService.Loggeduser.branchid).subscribe((res) => {
      this.billingService.billService = res;
      this.billsericeControll();
    })
  }

  billsericeControll() {
    this.BillsericeId = new FormControl();
    this.filterbillServiceArray = this.BillsericeId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filtersericefunction(item) : this.billingService.billService.slice())
      );
  }

  filtersericefunction(name: string) {
    return this.billingService.billService.filter(item =>
      item.billSerieseName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getbillSeriesObj(e) {
    var val = e.option.id;
    this.configurationService.selectedbillConfigData.fK_BillSerieseId = val
  }

  clearbillSeriesId(){
    if (!this.configurationService.selectedbillConfigData.billSerieseName ||  this.configurationService.selectedbillConfigData.billSerieseName.toString().trim() === '') {
      this.configurationService.selectedbillConfigData.fK_BillSerieseId = null;
    }
  }

  getDoctorBrach() {
    this.dashboardService.getall_doctors().pipe(takeUntil(this.destroypatientbilling$)).subscribe((res) => {
      this.opdvisitService.doctors = res
      this.doctorControll()
    })

  }

  doctorControll() {
    this.doctorId = new FormControl();
    this.filterdoctorArray = this.doctorId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterDrfunction(item) : this.opdvisitService.doctors.slice())
      );
  }

  filterDrfunction(name: string) {
    return this.opdvisitService.doctors.filter(item =>
      item.userName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getdoctorObj(e) {
    var val = e.option.id;
    this.configurationService.selectedbillConfigData.fK_DoctorId = val
  }

  cleardoctorId(){
    if (!this.configurationService.selectedbillConfigData.doctorName ||  this.configurationService.selectedbillConfigData.doctorName.toString().trim() === '') {
      this.configurationService.selectedbillConfigData.fK_DoctorId = null;
    }
  }

  refControll() {
    this.refId = new FormControl();
    this.filterRefArray = this.refId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterReffunction(item) : this.opdvisitService.personmaster.slice())
      );
  }

  filterReffunction(name: string) {
    return this.opdvisitService.personmaster.filter(item =>
      item.personName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getRefObj(e) {
    var val = e.option.id;
    this.configurationService.selectedbillConfigData.fK_ReferredById = val
  }

  clearreferralId(){
    if (!this.configurationService.selectedbillConfigData.referredPerson ||  this.configurationService.selectedbillConfigData.referredPerson.toString().trim() === '') {
      this.configurationService.selectedbillConfigData.fK_ReferredById = null;
    }
  }

  getRateList() {
    this.configurationService.GetrateListApi(this.authService.Loggeduser.branchid, 0).pipe(takeUntil(this.destroypatientbilling$)).subscribe((res) => {
      this.rateListArray = res
      this.rateControll();
    })
  }

  rateControll() {
    this.rateListId = new FormControl();
    this.filterRatelistArray = this.rateListId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterRatefunction(item) : this.rateListArray.slice())
      );
  }

  filterRatefunction(name: string) {
    return this.rateListArray.filter(item =>
      item.rateListName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getRateObj(e) {
    var val = e.option.id;
    this.configurationService.selectedbillConfigData.fK_RatelistId = val
  }

  clearRateId(){
    if (!this.configurationService.selectedbillConfigData.rateListName ||  this.configurationService.selectedbillConfigData.rateListName.toString().trim() === '') {
      this.configurationService.selectedbillConfigData.fK_RatelistId = null;
    }
  }


  getsearcgbrach() {
    this.configurationService.GetBillingConfigurationSetupByBillConfigurationId(0).pipe(takeUntil(this.destroypatientbilling$)).subscribe((res) => {
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message,"OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  getServiceList() {
    this.branchMatserService.getServicemaster(0, this.authService.Loggeduser.specialityId).pipe(takeUntil(this.destroypatientbilling$)).subscribe((res) => {
      this.serviceList = res
      this.serviceControll();
      this.reviewSerControll();
      this.followControll();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message,"OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  serviceControll() {
    this.freshServiceId = new FormControl();
    this.filterservicelistArray = this.freshServiceId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterservicefunction(item) : this.serviceList.slice())
      );
  }

  filterservicefunction(name: string) {
    return this.serviceList.filter(item =>
      item.serviceName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getFeshObj(e) {
    var val = e.option.id;
    this.configurationService.selectedbillConfigData.fK_FreshServiceId = val
  }

  clearfreashServiceId(){
    if (!this.configurationService.selectedbillConfigData.freashService ||  this.configurationService.selectedbillConfigData.freashService.toString().trim() === '') {
      this.configurationService.selectedbillConfigData.fK_FreshServiceId = null;
    }
  }

  reviewSerControll() {
    this.reviewServiceId = new FormControl();
    this.filterRservicelistArray = this.reviewServiceId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterRservicefunction(item) : this.serviceList.slice())
      );
  }

  filterRservicefunction(name: string) {
    return this.serviceList.filter(item =>
      item.serviceName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getreviewObj(e) {
    var val = e.option.id;
    this.configurationService.selectedbillConfigData.fK_ReviewServiceId = val
  }

  clearreviewServiceId(){
    if (!this.configurationService.selectedbillConfigData.reviewService ||  this.configurationService.selectedbillConfigData.reviewService.toString().trim() === '') {
      this.configurationService.selectedbillConfigData.fK_ReviewServiceId = null;
    }
  }

  followControll() {
    this.followUpId = new FormControl();
    this.filterfollowUplistArray = this.followUpId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterfollowfunction(item) : this.serviceList.slice())
      );
  }

  filterfollowfunction(name: string) {
    return this.serviceList.filter(item =>
      item.serviceName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getfollwObj(e) {
    var val = e.option.id;
    this.configurationService.selectedbillConfigData.fK_FollowupServiceId = val
  }

  clearfollowupId(){
    if (!this.configurationService.selectedbillConfigData.followup ||  this.configurationService.selectedbillConfigData.followup.toString().trim() === '') {
      this.configurationService.selectedbillConfigData.fK_FollowupServiceId = null;
    }
  }

  reset() {
    this.loadPaitentbillingForm();
    this.getServiceList()
    this.getBranchList();
    this.getpartyList();
    this.GetBillType();
    this.getBillMasterservice();
    this.getRateList();
    this.catControll();
    this.refControll();
    this.getDoctorBrach();
    this.BillingNarrationArray = [];
    this.configurationService.selectedbillConfigData = {};
    this.configurationService.selectedbillConfigData.fK_BranchId = null
    this.radiocheck1 = false;
    this.radiocheck2 = false;
    this.radiocheck3 = false;
    this.enabledisablebtn = true;
  }

  GetBillingNarration() {
    this.configurationService.GetBillingFooterNarrationByBranchId(this.configurationService.selectedbillConfigData.fK_BranchId).pipe(takeUntil(this.destroypatientbilling$)).subscribe((res) => {
      this.BillingNarrationArray = res;
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message,"OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  onRadioChange(event: any) {
    this.configurationService.selectedbillConfigData.consultationConfigType = event.value
  }

  radiohandle(){
    if(this.selectbillmstObj.consultationConfigType == 1){
      this.radiocheck1 = this.selectbillmstObj.consultationConfigType
      this.radiocheck2 = false
      this.radiocheck3 = false
    }
    if(this.selectbillmstObj.consultationConfigType == 2){
      this.radiocheck2 = this.selectbillmstObj.consultationConfigType
      this.radiocheck1 = false;
      this.radiocheck3 = false;
    }
    if(this.selectbillmstObj.consultationConfigType == 3){
      this.radiocheck3 = this.selectbillmstObj.consultationConfigType
      this.radiocheck1 = false
      this.radiocheck2 = false
    }
  }

  searchBrachMaster() {
    const dialogRef1 = this.dialog.open(SearchBillingConfigMasterComponent,{
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "80%",
      width: "90%",
      data: {
        enableButton: this.enabledisablebtn
      }
    });

    dialogRef1.afterClosed().subscribe((result) => {
      this.selectbillmstObj = this.configurationService.selectedbillConfigData;
      this.radiohandle();
      if (result) {
        this.insertbillingConfig.FK_BranchId = this.selectbillmstObj.fK_BranchId
        this.patinentBillingForm.patchValue({
          branchName: this.selectbillmstObj.branchName,
          partyName: this.selectbillmstObj.partyName,
          category: this.selectbillmstObj.categoryName,
          billType: this.selectbillmstObj.billTypeName,
          billSeries: this.selectbillmstObj.billSerieseName,
          doctorName: this.selectbillmstObj.doctorName,
          referralBy: this.selectbillmstObj.referredPerson,
          rateList: this.selectbillmstObj.rateListName,
          isActive: this.selectbillmstObj.isActive,
          approvalSystem: this.selectbillmstObj.approvalSystem,
          noofDays: this.selectbillmstObj.limitDays,
          freshService: this.selectbillmstObj.freashService,
          reviewService: this.selectbillmstObj.reviewService,
          followUp: this.selectbillmstObj.followup
        });
        this.GetBillingNarration();
        if (!this.configurationService.selectedbillConfigData.branchName ||  this.configurationService.selectedbillConfigData.branchName.toString().trim() === '') {
          this.enabledisablebtn = true;
        }else{
          this.enabledisablebtn = false;
        }
      }
    });
  }


  savebillconfiguration(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 2000);

    if (!this.configurationService.selectedbillConfigData.fK_BranchId) {
      this.dashboardService.openSnackBar("Please Select Branch First", "OK")
      return;
    }

    const isValid = this.BillingNarrationArray.every(item => 
      this.validBillTypeIds.indexOf(Number(item.fK_BillTypeId)) !== -1);
    if (!isValid) {
      this.dashboardService.openSnackBar('Please Enter Valid Bill Type','OK');
      return;
    }

    const partyInput = this.configurationService.selectedbillConfigData.partyName?.trim();
    if (partyInput) {
        const isInputValid = this.partylist.some(item => item.partyName?.toLowerCase() === partyInput.toLowerCase());
        if (!isInputValid) {
            this.dashboardService.openSnackBar("Please Select Correct Party Name","OK");
            return;
        }
    }

    const categoryInput = this.configurationService.selectedbillConfigData.categoryName?.trim();
    if (categoryInput) {
        const isInputValid = this.dashboardService.categories.some(item => item.categoryName?.toLowerCase() === categoryInput.toLowerCase());
        if (!isInputValid) {
            this.dashboardService.openSnackBar("Please Select Correct Category Name","OK");
            return;
        }
    }

    const billTypeInput = this.configurationService.selectedbillConfigData.billTypeName?.trim();
    if (billTypeInput) {
        const isInputValid = this.billingService.billtype.some(item => item.billTypeName?.toLowerCase() === billTypeInput.toLowerCase());
        if (!isInputValid) {
            this.dashboardService.openSnackBar("Please Select Correct Bill Type Name","OK");
            return;
        }
    }

    const billSeriesInput = this.configurationService.selectedbillConfigData.billSerieseName?.trim();
    if (billSeriesInput) {
        const isInputValid = this.billingService.billService.some(item => item.billSerieseName?.toLowerCase() === billSeriesInput.toLowerCase());
        if (!isInputValid) {
            this.dashboardService.openSnackBar("Please Select Correct Bill Service Name","OK");
            return;
        }
    }
    
    const doctorInput = this.configurationService.selectedbillConfigData.doctorName?.trim();
    if (doctorInput) {
        const isInputValid = this.opdvisitService.doctors.some(item => item.userName?.toLowerCase() === doctorInput.toLowerCase());
        if (!isInputValid) {
            this.dashboardService.openSnackBar("Please Select Correct DoctorName Name","OK");
            return;
        }
    }

    const referralInput = this.configurationService.selectedbillConfigData.referredPerson?.trim();
    if (referralInput) {
        const isInputValid = this.opdvisitService.personmaster.some(item => item.personName?.toLowerCase() === referralInput.toLowerCase());
        if (!isInputValid) {
            this.dashboardService.openSnackBar("Please Select Correct Referral Name","OK");
            return;
        }
    }

    const rateListInput = this.configurationService.selectedbillConfigData.rateListName?.trim();
    if (rateListInput) {
        const isInputValid = this.rateListArray.some(item => item.rateListName?.toLowerCase() === rateListInput.toLowerCase());
        if (!isInputValid) {
            this.dashboardService.openSnackBar("Please Select Correct RateList Name","OK");
            return;
        }
    }


    this.BillingNarrationArray.forEach((item, index) => {
      if(this.editCache[index] && this.editCache[index].edit){
        this.editCache[index].edit = false;}
      }
    );
    const InsertBillingConfig = {
      "PK_BillConfigurationId": this.configurationService.selectedbillConfigData.pK_BillConfigurationId ? this.configurationService.selectedbillConfigData.pK_BillConfigurationId : 0,
      "FK_BranchId": this.configurationService.selectedbillConfigData.fK_BranchId,
      "FK_PartyId": this.configurationService.selectedbillConfigData.fK_PartyId,
      "FK_CategoryId": this.configurationService.selectedbillConfigData.fK_CategoryId,
      "FK_BillTypeId": this.configurationService.selectedbillConfigData.fK_BillTypeId,
      "FK_BillSerieseId": this.configurationService.selectedbillConfigData.fK_BillSerieseId,
      "FK_DoctorId": this.configurationService.selectedbillConfigData.fK_DoctorId,
      "FK_ReferredById": this.configurationService.selectedbillConfigData.fK_ReferredById,
      "IsActive": this.configurationService.selectedbillConfigData.isActive,
      "ConsultationConfigType": this.configurationService.selectedbillConfigData.consultationConfigType,
      "FK_FreshServiceId": this.configurationService.selectedbillConfigData.fK_FreshServiceId,
      "FK_ReviewServiceId": this.configurationService.selectedbillConfigData.fK_ReviewServiceId,
      "FK_FollowupServiceId": this.configurationService.selectedbillConfigData.fK_FollowupServiceId,
      "LimitDays": this.configurationService.selectedbillConfigData.limitDays,
      "ApprovalSystem": this.configurationService.selectedbillConfigData.approvalSystem,
      "FK_RatelistId": this.configurationService.selectedbillConfigData.fK_RatelistId,
      "PrintTime": true,
      "TrueCopyDescription": null,
      "IsPrintAddress": "N",
      "ApprovalSystemEMR": this.configurationService.selectedbillConfigData.approvalSystemEMR,
      "ApprovalSystemOptical": this.configurationService.selectedbillConfigData.approvalSystemOptical,
      "ApprovalSystemPharmacy": this.configurationService.selectedbillConfigData.approvalSystemPharmacy,
      "IsEdit": this.configurationService.selectedbillConfigData.pK_BillConfigurationId ? true : false,
      "Mandatory_Party": false,
      "Mandatory_Category": false,
      "Mandatory_BillType": false,
      "Mandatory_BillSeries": false,
      "Mandatory_Doctor": false,
      "Mandatory_ReferredBy": false,
      "Mandatory_RateType": false,
      "Mandatory_Department": false
    }
    // let newItems = this.BillingNarrationArray.filter(item => item.pK_TranId === 0);
   var billingdata = [];
    this.BillingNarrationArray.forEach((item) => {
      // if (item.pK_TranId == 0) {
        if(item.narration && item.fK_BillTypeId){
          billingdata.push({
            "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
            "Narration": item.narration,
            "FK_BillTypeId": item.fK_BillTypeId,
            "IsEdit": item.pK_TranId ? true : false,
            "IsDelete": item.IsDelete ? true :false
          })
        // }
    }
    })
    let payload = {
      InsertBillingConfigurationSetupDto: InsertBillingConfig,
      InsertBillingFooterNarrationDto: billingdata.concat(this.deleteArray)
    }
    this.configurationService.InsertBillingConfigurationSetup(payload).pipe(takeUntil(this.destroypatientbilling$)).subscribe((x: any) => {
      if (x && x.statusCode === "10") { 
        this.dashboardService.openSnackBar(`Configuration for ${this.configurationService.selectedbillConfigData.branchName} is already exists`, "OK")
        this.reset();
       }
      if (x && x.statusCode === "1") {
        this.getsearcgbrach();
        this.configurationService.GetBillingFooterNarrationByBranchId(this.configurationService.selectedbillConfigData.fK_BranchId).pipe(takeUntil(this.destroypatientbilling$)).subscribe((res) => {
        }, err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message,"OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        })
        this.dashboardService.openSnackBar(InsertBillingConfig.PK_BillConfigurationId == 0 ? "Record Save Successfully" : "Record Updated Successfully", "OK");
        this.reset();
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message,"OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  ngOnDestroy() {
    this.destroypatientbilling$.next(true);
    this.destroypatientbilling$.unsubscribe();
    this.filteredBranchArray = null
    this.filterpartyArray = null;
    this.filtercatArray = null;
    this.filterbillTypeArray = null;
    this.filterbillServiceArray = null;
    this.filterdoctorArray = null;
    this.filterRefArray = null;
    this.filterRatelistArray = null;
    this.filterservicelistArray = null;
    this.filterRservicelistArray = null;
    this.filterfollowUplistArray = null;
    this.rateListArray = null;
    this.serviceList = null;
    this.BillingNarrationArray = null;
    this.getBillingNarrationArray = null;
    this.selectbillmstObj = null;
    this.addbillConobj = null;
    this.insertbillingConfig = null;
    this.configurationService.selectedbillConfigData.limitDays = null;
  }
}
